export enum MobileOsType {
  ANDROID = 'ANDROID',
  IOS = 'IOS',
}
